import React, { useEffect, useMemo, useState } from "react";

const pageStyle = {
  minHeight: "100vh",
  background:
    "radial-gradient(circle at 20% 0%, rgba(47,123,255,0.18), transparent 30%), radial-gradient(circle at 80% 10%, rgba(94,92,230,0.14), transparent 28%), linear-gradient(180deg, #050816 0%, #09101F 42%, #0C1423 100%)",
  color: "#F8FAFC",
  padding: "40px 20px 80px",
};

const containerStyle = {
  maxWidth: "760px",
  margin: "0 auto",
};

const cardStyle = {
  background: "rgba(13, 17, 28, 0.72)",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: "30px",
  boxShadow:
    "0 18px 60px rgba(0, 0, 0, 0.38), inset 0 1px 0 rgba(255,255,255,0.06)",
  backdropFilter: "blur(18px)",
  WebkitBackdropFilter: "blur(18px)",
  padding: "32px",
};

const titleStyle = {
  fontSize: "clamp(30px, 5vw, 42px)",
  lineHeight: 1.08,
  fontWeight: 800,
  letterSpacing: "-0.04em",
  margin: "0 0 10px",
};

const paragraphStyle = {
  fontSize: "15px",
  lineHeight: 1.7,
  color: "rgba(226,232,240,0.82)",
  margin: "0 0 20px",
};

const badgeRowStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "10px",
  marginBottom: "20px",
};

const badgeBaseStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  padding: "10px 14px",
  borderRadius: "999px",
  fontSize: "13px",
  fontWeight: 700,
  border: "1px solid rgba(255,255,255,0.08)",
};

const uploadBoxStyle = {
  border: "1px dashed rgba(255,255,255,0.16)",
  borderRadius: "24px",
  background: "rgba(255,255,255,0.03)",
  padding: "22px",
};

const fileInputStyle = {
  width: "100%",
  padding: "16px",
  borderRadius: "18px",
  border: "1px solid rgba(255,255,255,0.10)",
  background: "rgba(255,255,255,0.04)",
  color: "#F8FAFC",
  fontSize: "15px",
  outline: "none",
};

const helperTextStyle = {
  marginTop: "10px",
  fontSize: "13px",
  color: "rgba(226,232,240,0.70)",
  lineHeight: 1.6,
};

const simpleStatsStyle = {
  display: "flex",
  gap: "10px",
  flexWrap: "wrap",
  marginTop: "16px",
};

const statChipStyle = {
  padding: "10px 14px",
  borderRadius: "999px",
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(255,255,255,0.08)",
  fontSize: "13px",
  color: "#E2E8F0",
};

const fileListStyle = {
  display: "grid",
  gap: "12px",
  marginTop: "18px",
};

const fileCardStyle = {
  display: "grid",
  gridTemplateColumns: "84px 1fr auto",
  gap: "14px",
  alignItems: "center",
  borderRadius: "20px",
  padding: "12px",
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(255,255,255,0.08)",
};

const thumbStyle = {
  width: "84px",
  height: "84px",
  objectFit: "cover",
  borderRadius: "16px",
  border: "1px solid rgba(255,255,255,0.08)",
  background: "rgba(255,255,255,0.05)",
};

const fileNameStyle = {
  fontSize: "15px",
  fontWeight: 700,
  color: "#F8FAFC",
  margin: "0 0 6px",
  wordBreak: "break-word",
};

const fileMetaStyle = {
  fontSize: "13px",
  color: "rgba(226,232,240,0.74)",
  margin: 0,
  lineHeight: 1.6,
};

const removeButtonStyle = {
  padding: "10px 14px",
  borderRadius: "999px",
  border: "1px solid rgba(255,255,255,0.10)",
  background: "rgba(255,255,255,0.04)",
  color: "#F8FAFC",
  cursor: "pointer",
  fontWeight: 700,
  fontSize: "13px",
};

const primaryButtonStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  gap: "10px",
  padding: "16px 24px",
  borderRadius: "999px",
  background: "linear-gradient(135deg, #2F7BFF 0%, #5E5CE6 100%)",
  color: "#FFFFFF",
  textDecoration: "none",
  fontWeight: 700,
  fontSize: "15px",
  letterSpacing: "-0.01em",
  boxShadow: "0 12px 30px rgba(47, 123, 255, 0.25)",
  border: "1px solid rgba(255,255,255,0.08)",
  cursor: "pointer",
  marginTop: "20px",
};

const secondaryButtonStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  gap: "10px",
  padding: "15px 24px",
  borderRadius: "999px",
  background: "rgba(255,255,255,0.04)",
  color: "#E2E8F0",
  textDecoration: "none",
  fontWeight: 700,
  fontSize: "15px",
  letterSpacing: "-0.01em",
  border: "1px solid rgba(255,255,255,0.10)",
  cursor: "pointer",
  marginTop: "12px",
};

const messageStyle = {
  marginTop: "18px",
  borderRadius: "18px",
  padding: "14px 16px",
  border: "1px solid rgba(255,255,255,0.08)",
  background: "rgba(255,255,255,0.04)",
  fontSize: "14px",
  lineHeight: 1.7,
  color: "#E2E8F0",
};

const progressWrapStyle = {
  marginTop: "16px",
};

const progressTrackStyle = {
  width: "100%",
  height: "12px",
  borderRadius: "999px",
  background: "rgba(255,255,255,0.08)",
  overflow: "hidden",
};

const backLinkStyle = {
  display: "inline-flex",
  alignItems: "center",
  color: "#C7D2FE",
  textDecoration: "none",
  marginBottom: "22px",
  fontSize: "15px",
};

function formatBytes(bytes) {
  if (!bytes && bytes !== 0) return "-";
  if (bytes === 0) return "0 B";

  const units = ["B", "KB", "MB", "GB"];
  const index = Math.floor(Math.log(bytes) / Math.log(1024));
  const value = bytes / 1024 ** index;

  return `${value.toFixed(value >= 10 || index === 0 ? 0 : 1)} ${units[index]}`;
}

export default function PaymentSuccessPhotoUpload() {
  const backendUrl = import.meta.env.VITE_STRIPE_BACKEND_URL;

  const [sessionId, setSessionId] = useState("");
  const [sessionValid, setSessionValid] = useState(false);
  const [statusMessage, setStatusMessage] = useState("Ödeme kontrol ediliyor...");
  const [isCheckingSession, setIsCheckingSession] = useState(true);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadedCount, setUploadedCount] = useState(0);
  const [uploadFinished, setUploadFinished] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const currentSessionId = params.get("session_id") || "";

    setSessionId(currentSessionId);

    if (!backendUrl) {
      setStatusMessage("Bağlantı ayarı eksik.");
      setIsCheckingSession(false);
      return;
    }

    if (!currentSessionId) {
      setStatusMessage("Geçerli bir oturum bulunamadı.");
      setIsCheckingSession(false);
      return;
    }

    const verifySession = async () => {
      try {
        const response = await fetch(
          `${backendUrl}/verify-session/${encodeURIComponent(currentSessionId)}`
        );

        const data = await response.json();

        if (!response.ok || !data.valid) {
          throw new Error(data.error || "Ödeme doğrulanamadı.");
        }

        setSessionValid(true);
        setStatusMessage("Ödeme doğrulandı. Fotoğrafları yükleyebilirsiniz.");
      } catch (error) {
        console.error("Session verify error:", error);
        setSessionValid(false);
        setStatusMessage(error.message || "Bir sorun oluştu.");
      } finally {
        setIsCheckingSession(false);
      }
    };

    verifySession();
  }, [backendUrl]);

  useEffect(() => {
    return () => {
      selectedFiles.forEach((file) => {
        if (file.previewUrl) {
          URL.revokeObjectURL(file.previewUrl);
        }
      });
    };
  }, [selectedFiles]);

  const totalSize = useMemo(() => {
    return selectedFiles.reduce((sum, file) => sum + (file.size || 0), 0);
  }, [selectedFiles]);

  const progressPercent = useMemo(() => {
    if (!selectedFiles.length) return 0;
    return Math.round((uploadedCount / selectedFiles.length) * 100);
  }, [uploadedCount, selectedFiles.length]);

  const handleFileChange = (event) => {
    const incomingFiles = Array.from(event.target.files || []);

    if (!incomingFiles.length) {
      setSelectedFiles([]);
      setUploadFinished(false);
      return;
    }

    const preparedFiles = incomingFiles
      .filter((file) => file.type.startsWith("image/"))
      .map((file, index) => ({
        id: `${file.name}-${file.size}-${file.lastModified}-${index}`,
        file,
        name: file.name,
        size: file.size,
        type: file.type,
        previewUrl: URL.createObjectURL(file),
      }));

    setSelectedFiles((prev) => {
      prev.forEach((item) => {
        if (item.previewUrl) {
          URL.revokeObjectURL(item.previewUrl);
        }
      });
      return preparedFiles;
    });

    setUploadedCount(0);
    setUploadFinished(false);

    if (preparedFiles.length !== incomingFiles.length) {
      setStatusMessage("Sadece görsel dosyalar eklendi.");
    } else {
      setStatusMessage("Fotoğraflar seçildi.");
    }
  };

  const handleRemoveFile = (fileId) => {
    setSelectedFiles((prev) => {
      const fileToRemove = prev.find((item) => item.id === fileId);
      if (fileToRemove?.previewUrl) {
        URL.revokeObjectURL(fileToRemove.previewUrl);
      }
      return prev.filter((item) => item.id !== fileId);
    });
  };

  const uploadSingleFile = async (wrappedFile) => {
    const presignResponse = await fetch(`${backendUrl}/create-upload-url`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        sessionId,
        fileName: wrappedFile.name,
        fileType: wrappedFile.type || "application/octet-stream",
      }),
    });

    const presignData = await presignResponse.json();

    if (!presignResponse.ok) {
      throw new Error(presignData.error || "Upload linki oluşturulamadı.");
    }

    const uploadResponse = await fetch(presignData.uploadUrl, {
      method: "PUT",
      headers: {
        "Content-Type": wrappedFile.type || "application/octet-stream",
      },
      body: wrappedFile.file,
    });

    if (!uploadResponse.ok) {
      throw new Error(`${wrappedFile.name} yüklenemedi.`);
    }

    return {
      originalName: wrappedFile.name,
      objectKey: presignData.objectKey,
      fileType: wrappedFile.type || "application/octet-stream",
    };
  };

  const handleUpload = async () => {
    if (!backendUrl) {
      setStatusMessage("Bağlantı ayarı eksik.");
      return;
    }

    if (!sessionValid || !sessionId) {
      setStatusMessage("Geçerli ödeme oturumu bulunamadı.");
      return;
    }

    if (!selectedFiles.length) {
      setStatusMessage("Lütfen fotoğraf seçin.");
      return;
    }

    try {
      setIsUploading(true);
      setUploadedCount(0);
      setUploadFinished(false);
      setStatusMessage("Fotoğraflar yükleniyor...");

      const uploadedFiles = [];

      for (const item of selectedFiles) {
        const result = await uploadSingleFile(item);
        uploadedFiles.push(result);
        setUploadedCount((prev) => prev + 1);
      }

      const saveResponse = await fetch(`${backendUrl}/save-uploaded-files`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          sessionId,
          files: uploadedFiles,
        }),
      });

      const saveData = await saveResponse.json();

      if (!saveResponse.ok) {
        throw new Error(saveData.error || "Dosyalar kaydedilemedi.");
      }

      setUploadFinished(true);
      setStatusMessage("Fotoğraflar yüklendi.");
    } catch (error) {
      console.error("Upload error:", error);
      setUploadFinished(false);
      setStatusMessage(error.message || "Yükleme sırasında hata oluştu.");
    } finally {
      setIsUploading(false);
    }
  };

  const resetSelectedFiles = () => {
    selectedFiles.forEach((item) => {
      if (item.previewUrl) {
        URL.revokeObjectURL(item.previewUrl);
      }
    });
    setSelectedFiles([]);
    setUploadedCount(0);
    setUploadFinished(false);
    setStatusMessage("Yeni fotoğraflar seçebilirsiniz.");
  };

  return (
    <div style={pageStyle}>
      <div style={containerStyle}>
        <a href="/gc-about" style={backLinkStyle}>
          ← Geri dön
        </a>

        <div style={cardStyle}>
          <h1 style={titleStyle}>Fotoğraf Yükleme</h1>

          <p style={paragraphStyle}>Fotoğraflarınızı seçin ve yükleyin.</p>

          <div style={badgeRowStyle}>
            <div
              style={{
                ...badgeBaseStyle,
                background: sessionValid
                  ? "rgba(34,197,94,0.12)"
                  : "rgba(248,113,113,0.10)",
                color: sessionValid ? "#86EFAC" : "#FCA5A5",
              }}
            >
              {sessionValid ? "● Ödeme doğrulandı" : "● Doğrulama bekleniyor"}
            </div>

            <div
              style={{
                ...badgeBaseStyle,
                background: "rgba(96,165,250,0.10)",
                color: "#BFDBFE",
              }}
            >
              {selectedFiles.length} dosya seçildi
            </div>
          </div>

          <div style={messageStyle}>{statusMessage}</div>

          <div style={uploadBoxStyle}>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handleFileChange}
              disabled={!sessionValid || isCheckingSession || isUploading}
              style={fileInputStyle}
            />

            <div style={simpleStatsStyle}>
              <div style={statChipStyle}>Toplam: {formatBytes(totalSize)}</div>
              <div style={statChipStyle}>
                Yüklenen: {uploadedCount}/{selectedFiles.length || 0}
              </div>
            </div>

            {selectedFiles.length > 0 && (
              <div style={fileListStyle}>
                {selectedFiles.map((item) => (
                  <div key={item.id} style={fileCardStyle}>
                    <img
                      src={item.previewUrl}
                      alt={item.name}
                      style={thumbStyle}
                    />

                    <div>
                      <p style={fileNameStyle}>{item.name}</p>
                      <p style={fileMetaStyle}>{formatBytes(item.size)}</p>
                    </div>

                    <button
                      type="button"
                      onClick={() => handleRemoveFile(item.id)}
                      disabled={isUploading}
                      style={{
                        ...removeButtonStyle,
                        opacity: isUploading ? 0.55 : 1,
                        cursor: isUploading ? "not-allowed" : "pointer",
                      }}
                    >
                      Kaldır
                    </button>
                  </div>
                ))}
              </div>
            )}

            {isUploading && (
              <div style={progressWrapStyle}>
                <div style={progressTrackStyle}>
                  <div
                    style={{
                      width: `${progressPercent}%`,
                      height: "100%",
                      borderRadius: "999px",
                      background:
                        "linear-gradient(135deg, #2F7BFF 0%, #5E5CE6 100%)",
                      transition: "width 0.25s ease",
                    }}
                  />
                </div>
                <p style={{ ...helperTextStyle, marginBottom: 0 }}>
                  %{progressPercent}
                </p>
              </div>
            )}

            <button
              type="button"
              onClick={handleUpload}
              disabled={
                !sessionValid ||
                isCheckingSession ||
                isUploading ||
                !selectedFiles.length
              }
              style={{
                ...primaryButtonStyle,
                opacity:
                  !sessionValid ||
                  isCheckingSession ||
                  isUploading ||
                  !selectedFiles.length
                    ? 0.6
                    : 1,
                cursor:
                  !sessionValid ||
                  isCheckingSession ||
                  isUploading ||
                  !selectedFiles.length
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              {isUploading ? "Yükleniyor..." : "Fotoğrafları Yükle"}
            </button>

            <button
              type="button"
              onClick={resetSelectedFiles}
              disabled={isUploading || !selectedFiles.length}
              style={{
                ...secondaryButtonStyle,
                opacity: isUploading || !selectedFiles.length ? 0.6 : 1,
                cursor:
                  isUploading || !selectedFiles.length
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              Temizle
            </button>

            {uploadFinished && (
              <div
                style={{
                  ...messageStyle,
                  background: "rgba(34,197,94,0.10)",
                  border: "1px solid rgba(34,197,94,0.22)",
                  color: "#BBF7D0",
                }}
              >
                Fotoğraflar başarıyla yüklendi. Raporlarınız en kısa sürede
                WhatsApp üzerinden size ulaştırılacaktır.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}